import { createSlice } from '@reduxjs/toolkit';
import { IStore } from '@/domain/interfaces/IStore';
import { store } from '@/data/libraries/Store';

/** Objeto inicial info de tienda */
const initialState: IStore = {
  name: '',
  showContactUs: false,
  showAboutUs: false,
  termsAndConditions: {
    title: '',
    message: '',
    subject: '',
  },
  layoutCode: 0,
  shippingCost: '0',
  notificationsEmail: '',
  notificationsPhone: { country: '', number: '' },
  maxProductPrice: 0,
  purchaseOnlyClient: false,
  appointments: false,
  hideCatalogData: false,
  storeId: store.DEFAULT,
  language: '',
  dictionary: {},
  yewelryCertification: false,
  urlYewelryCertification: '',
  onlyChileanRegion: false,
  blog: null,
  privacyPolicyUrl: '',
  termsConditionsUrl: '',
};

/** Almacena el estado userState de Redux con sus reducers
 * @constant {object}
 */
export const storeDataSlice = createSlice({
  name: 'storeData',
  initialState,
  reducers: {
    updateStoreState: (_, action) => ({ ...action.payload }),
  },
});

export const { updateStoreState } = storeDataSlice.actions;

export default storeDataSlice.reducer;
